import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  HostListener,
  HostBinding,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import * as d3 from "d3";
import { Subject, Subscription, takeUntil } from "rxjs";
import { CurrencyPipe } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { FilterService } from "src/app/services/filter.service";
import { RouterHandlerService } from "src/app/services/router-handler.service";
import { NavigationService } from "src/app/services/navigation.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-scatter-chart",
  templateUrl: "./scatter-chart.component.html",
  styleUrls: ["./scatter-chart.component.scss"],
})
export class Scatter4QChartComponent implements OnInit, OnDestroy {
  @ViewChild("chartContainer", { static: true }) chartContainer!: ElementRef;
    @ViewChild('fs') fs!: ElementRef;
    @HostBinding('class.is-fullscreen') isFullscreen = false;
  
    @Input('data') data: any;
    @Input('pageKey') pageKey: any;
    @Input('item') item: any;
    @Input('config') config: any;
    @Input('headerConfig') headerConfig: any;
    @Input('heading') heading: string = '';
    @Input('error_name') error_name: any;
    @Input('prefrenceConfig') prefrenceConfig: any;
    @Input('showBubbleCount') showBubbleCount: boolean = false;
    @Output() showBychanges = new EventEmitter();


    reqSubcription: Subscription[] = [];
    territoriesCard: boolean = true
    showByvalue: any = 'D';
    isActive = false;
    iconList: any[] = [];
    HbarChartData: any = [];
    props: any;
    divId: any = 'HbarChartDiv' // "WordCloudChartDiv";
    headerDivId: any = "HbarHeader";
    initiateChart: Boolean = false;
    noData: boolean = false;
    mytooltipData: any;
    dataTurn: any;
    tooltip: any;
    tooltipID: any = "d3WordCloudTooltip"
    tooltipType: any;
    clientKey: any;
    moduleKey: any;
    dashboardKey: any;
    cardName: any;
    cardId: any;
    moduleName: any;
    decryptedParams: any;
    subs: Subscription[] = [];
    isLoading = false;
  
    @HostListener('fullscreenchange', ['$event'])
    @HostListener('webkitfullscreenchange', ['$event'])
    @HostListener('mozfullscreenchange', ['$event'])
    @HostListener('MSFullscreenChange', ['$event'])
    screenChange(event: any) {
      if (!document.fullscreenElement) {
        this.closeFullscreen();
      }
    }
    
    constructor(
      private filterService: FilterService,
      private route: ActivatedRoute,
      private navigationService: NavigationService,
      private routerHandlerService: RouterHandlerService,
      private currency: CurrencyPipe,
      private snackBar: MatSnackBar,
      private cdr: ChangeDetectorRef
    ) {
      this.subs.push(
        this.filterService.filterQuery.subscribe((query: any) => {
          this.start();
        }))
      this.route.params.subscribe((p: any) => {
        this.moduleName = p['module'] || '';
        this.cardName = p['cardName'] || '';
        this.route.queryParams.subscribe((params: any) => {
          this.decryptedParams = this.navigationService.decryptData(params);
          this.clientKey = this.decryptedParams["cl_key"];
          this.moduleKey = this.decryptedParams["md_key"];
          this.dashboardKey = this.decryptedParams["ds_key"];
        });
      });
    //    this.reqSubcription.push(
    //   this.filterService.chartshowBy.subscribe((res: any) => {
    //     const widgetKey = res?.item?.widget_uniq_key;
    //     if (widgetKey == this.item.widget_uniq_key) {
    //       this.isLoading = true;
    //       // this.loadData();
    //       this.showBychanges.emit(res.value);
    //     }
    //   })
    // );
    }
  
    numbedPipe(value: any) {
      if(value==null || value==undefined || value=='' || value==0){return 0;}
      return this.currency.transform(value, '', '', '1.0-2');
    }
  
  
    start() { this.isLoading = true; }

  institutions: any[] = [];
  allInstitutions: any[] = [];
  selectedInstitutions: any[] = [];
  territoryColors: any[] = [];
  keyTerritories: any[] = [];
  selectedTerritories: Set<string> = new Set();

  activeTab: "less" | "more" = "less";
  private filterApplied = false;

  // Unified color palette for all chart elements
  private readonly colorPalette: string[] = [
    "#E74028", "#2CB239", "#25D3EB", "#FFB039", "#1566DE", "#7848FF", "#7AD045", "#CB04DC", "#FA195C", "#9E0000",
    "#EACD37", "#DD630B", "#BCD03F", "#14BDA9", "#8A05F3", "#D9476A", "#2DADB6", "#E468C2", "#199CD4", "#0934CC",
    '#1F2B97', '#2B6BCB', '#2F3CAF', '#3E85EF', '#404CBB', '#4832A1', '#49ACA0', '#58B3B9', '#5EDE6B', '#663DBC',
    '#6651BE', '#6BCFDD', '#7458E7', '#7559C5', '#81B661', '#B04747', '#BB3847', '#BBAB54', '#BFC23D', '#C45B0F',
    '#C75FD0', '#D0662A', '#D25297', '#DD6287', '#DE7D48', '#E29063', '#FF5740', '#FFC164',
    "#e74c3c", "#3498db", "#2ecc71", "#f1c40f", "#9b59b6", "#1abc9c", "#34495e", "#e67e22", "#16a085", "#d35400",
    "#2980b9", "#8e44ad", "#c0392b", "#27ae60", "#f39c12", "#7f8c8d"
  ];

  // Raw API data storage for tab filtering
  private rawApiData: any[] = [];

  // Tooltip popup properties
  showSelectionTooltip = false;
  tooltipPosition = { x: 0, y: 0 };

  private svg: any;
  private chartGroup: any;
  private xScale: any;
  private yScale: any;
  private defaultHeight = 500;
  private dimensions: any = {
    width: 800,
    height: 500,
    margin: { top: 10, right: 10, bottom: 60, left: 60 },
  };

  // Lasso selection
  private lassoArea: any;
  private lassoPath: any;
  private lassoPoints: [number, number][] = [];

  ngOnInit(): void {
    this.initializeProps();
    this.start();
   
    // this.loadData();
  }

  private showByMapping: any = {
    'S': {
      nameVar: 'institution_name',
      idVar: 'source_key',
      territoryVar: 'institution_name',
      territoryKeyVar: 'source_key',
      institutionKeyVar: 'source_key'
    },
    'D': {
      nameVar: 'territory_name',
      idVar: 'territory_key',
      territoryVar: 'territory_name',
      territoryKeyVar: 'territory_key',
      institutionKeyVar: 'territory_key'
    }
  };

  private initializeProps(): void {
    const cfg = this.item?.config || this.config || {};

    // Read persisted showBy selection (same pattern as icon-chart)
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    const defaultShowBy = this.headerConfig?.find((f: any) => f.value === 'show_by')?.show_by_value?.[0]?.value || 'S';
    this.showByvalue = this.filterService.getShowBySelection(widgetKey) ?? defaultShowBy;
    this.filterService.currentShowbySelection = this.showByvalue;

    // Get dynamic field mapping based on current showBy value
    const dynamicFields = this.showByMapping[this.showByvalue] || this.showByMapping['S'];

    this.props = {
      // Labels
      xAxisLabel:       cfg.xAxisLabel       || 'Patients',
      yAxisLabel:       cfg.yAxisLabel       || 'Discontinuation rate',
      // Field variable names — dynamically set based on showBy
      xAxisVar:         cfg.xAxisVar         || 'total_patients',
      yAxisVar:         cfg.yAxisVar         || 'early_drop_pct',
      bubbleSizeVar:    cfg.bubbleSizeVar    || 'patient_count',
      idVar:            dynamicFields.idVar,
      nameVar:          dynamicFields.nameVar,
      territoryVar:     dynamicFields.territoryVar,
      territoryKeyVar:  dynamicFields.territoryKeyVar,
      institutionKeyVar:dynamicFields.institutionKeyVar,
      categoryVar:      cfg.categoryVar      || 'discontinued_category',
      // Chart settings
      chartHeight:      this.isFullscreen ? window.innerHeight - 150 : (cfg.chartHeight || 500),
      showBubbleCount:  this.showBubbleCount,
      colors:           this.colorPalette
    };
  }

  showBySubs(event: any) {
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';

    // Reset legend selection when showBy changes
    this.selectedTerritories.clear();

    // Persist selection to localStorage (same pattern as icon-chart)
    this.filterService.setShowBySelection(widgetKey, event);

    // Update filterService state
    this.filterService.chartshowBy.next({
      widget: this.item?.['key'],
      value: event,
      item: this.item
    });
    this.filterService.currentShowbySelection = event;
    this.showByvalue = event;

    // Re-initialize all props with updated showBy value
    this.initializeProps();

    // Emit to parent to trigger new API call with updated report_typ
    this.showBychanges.emit(event);
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      const newData = changes['data'].currentValue;
      this.rawApiData = (newData && Array.isArray(newData)) ? newData : [];
      if (!changes['data'].firstChange) {
        this.loadData();
      }
    }
  }

    fullscreenChanges(fullscreen: any) {
    if (fullscreen == false) {
      // If the function is called with false explicitly, exit fullscreen
      this.closeFullscreen();
      return;
    }
    // Capture old chart dimensions before resizing
    const oldChartWidth = this.dimensions.width - this.dimensions.margin.left - this.dimensions.margin.right;
    const oldChartHeight = this.dimensions.height - this.dimensions.margin.top - this.dimensions.margin.bottom;

    this.isFullscreen = true;
    this.isActive = true;
    this.initializeProps();

    // Preserve selection state — just resize and re-render without reprocessing data
    const hadSelection = this.showSelectionTooltip && this.selectedInstitutions.length > 0;
    const hadLasso = this.lassoPoints.length > 0;

    setTimeout(() => {
      this.updateDimensions();
      this.scaleLassoPoints(oldChartWidth, oldChartHeight);
      this.renderChart();
      this.applyTerritoryOpacity();

      // Restore selection tooltip if it was visible before fullscreen
      if (hadSelection) {
        setTimeout(() => this.showTooltipAtLasso(), 50);
      }
    }, 200);
  }

  closeFullscreen(): void {
    // Capture old chart dimensions before resizing
    const oldChartWidth = this.dimensions.width - this.dimensions.margin.left - this.dimensions.margin.right;
    const oldChartHeight = this.dimensions.height - this.dimensions.margin.top - this.dimensions.margin.bottom;

    this.isFullscreen = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    this.dimensions.height = this.defaultHeight;
    this.isActive = false;
    this.initializeProps();

    // Preserve selection state — just resize and re-render without reprocessing data
    const hadSelection = this.showSelectionTooltip && this.selectedInstitutions.length > 0;

    setTimeout(() => {
      this.updateDimensions();
      this.scaleLassoPoints(oldChartWidth, oldChartHeight);
      this.renderChart();
      this.applyTerritoryOpacity();

      // Restore selection tooltip if it was visible before exiting fullscreen
      if (hadSelection) {
        setTimeout(() => this.showTooltipAtLasso(), 50);
      }
    }, 200);
  }

  private scaleLassoPoints(oldChartWidth: number, oldChartHeight: number): void {
    if (this.lassoPoints.length === 0) return;
    const { margin } = this.dimensions;
    const newChartWidth = this.dimensions.width - margin.left - margin.right;
    const newChartHeight = this.dimensions.height - margin.top - margin.bottom;
    if (oldChartWidth <= 0 || oldChartHeight <= 0) return;

    const scaleX = newChartWidth / oldChartWidth;
    const scaleY = newChartHeight / oldChartHeight;
    this.lassoPoints = this.lassoPoints.map(([x, y]) => [x * scaleX, y * scaleY]);
  }

  ngOnDestroy(): void {
    if (this.scrollHideHandler) {
      window.removeEventListener('scroll', this.scrollHideHandler, { capture: true } as any);
      this.scrollHideHandler = null;
    }
    if (this.hoverTooltip) {
      this.hoverTooltip.style('opacity', 0);
    }
  }

  @HostListener("window:resize")
  onResize(): void {
    setTimeout(() => {
      this.updateDimensions();
      this.renderChart();
      this.applyTerritoryOpacity();
    }, 200);
  }

  loadData(): void {
    // Enter loading state and hide tooltips while data loads
    this.isLoading = true;
    this.showSelectionTooltip = false;
    if (this.hoverTooltip) {
      this.hoverTooltip.style("opacity", 0);
    }

    // Use raw API data from @Input or cached
    const apiData = (this.data && Array.isArray(this.data) && this.data.length > 0)
     ? this.data  : null;

    // Reset legend selection on data change
    this.selectedTerritories.clear();

    if (apiData && apiData.length > 0) {
      // Store raw data for tab switching
      if (this.rawApiData.length === 0) {
        this.rawApiData = apiData;
      }
      this.processApiData(apiData);
    } else {
      // No data available
      this.institutions = [];
      this.allInstitutions = [];
      this.selectedInstitutions = [];
      this.keyTerritories = [];
      this.territoryColors = [];
      this.noData = true;
      this.isLoading = false;
      return;
    }

    // Check if processApiData produced any institutions
    if (this.institutions.length === 0) {
      this.noData = true;
      this.isLoading = false;
      return;
    }

    this.noData = false;

    setTimeout(() => {
      this.updateDimensions();
      this.renderChart();
    }, 100);
  }

  private processApiData(apiData: any[]): void {
    if (!apiData || !Array.isArray(apiData) || apiData.length === 0) {
      return;
    }

    // Determine the target discontinued_category based on activeTab
    const targetCategory = this.activeTab === 'less' ? 'Less than 6 Fills' : 'Greater than 6 Fills';

    // Use configurable category field (from props, set via item.config)
    const categoryVar = this.props?.categoryVar || 'discontinued_category';
    const hasCategory = apiData.some((item: any) => item[categoryVar]);

    // Filter by category if present, else use all data
    const filteredData = hasCategory
      ? apiData.filter((item: any) => item[categoryVar] === targetCategory)
      : apiData;

    // Transform API data — field names come directly from props (item.config),
    // following the same pattern as small-bar-chart: d[myChart.props.barVar]
    this.institutions = filteredData
      .map((item: any, index: number) => {
        return {
          id:                  item[this.props.idVar]             ?? String(index + 1),
          name:                item[this.props.nameVar]           ?? `Institution ${index + 1}`,
          territory:           item[this.props.territoryVar]      ?? 'Unknown',
          totalPatients:       Number(item[this.props.xAxisVar])  || 0,
          discontinuedFiles:   Number(item[this.props.bubbleSizeVar]) || 0,
          discontinuationRate: Number(item[this.props.yAxisVar])  || 0,
          territoryKey:        item[this.props.territoryKeyVar]   ?? `territory_${index + 1}`,
          institutionKey:      item[this.props.institutionKeyVar] ?? `institution_${index + 1}`,
          selected: false
        };
      })
      .filter((inst: any) => inst.discontinuedFiles > 0 || inst.totalPatients > 0 || inst.discontinuationRate > 0);

    this.allInstitutions = [...this.institutions];
    this.selectedInstitutions = [];
    
    // Calculate key territories from API data
    this.keyTerritories = this.getKeyTerritories(this.institutions);
    
    // Generate territory colors dynamically
    this.generateTerritoryColors();
  }

  private generateTerritoryColors(): void {
    // Get unique territories from institutions, sorted alphabetically
    const uniqueTerritories = [...new Set(this.institutions.map(inst => inst.territory))].sort((a, b) => a.localeCompare(b));
    
    // Generate colors for each territory
    this.territoryColors = uniqueTerritories.map((territory, index) => ({
      territory: territory,
      color: this.colorPalette[index % this.colorPalette.length]
    }));
  }

  switchTab(tab: "less" | "more"): void {
    if (this.selectedInstitutions.length > 0) {
      this.snackBar.open('Please reset the lasso selection before switching tabs.', 'OK', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
      // Force tab back visually using change detection trick
      const current = this.activeTab;
      this.activeTab = tab;
      this.cdr.detectChanges();
      this.activeTab = current;
      this.cdr.detectChanges();
      return;
    }
    this.activeTab = tab;
    this.loadData();
  }

  private updateDimensions(): void {
    const rect = this.chartContainer.nativeElement.getBoundingClientRect();
    this.dimensions.width = rect.width || 800;
    this.dimensions.height = this.isFullscreen
      ? Math.max(300, window.innerHeight - 150)
      : this.defaultHeight;
  }

  private hoverTooltip: any;
  private scrollHideHandler: (() => void) | null = null;

  private renderChart(): void {
    // Clear existing chart
    d3.select(this.chartContainer.nativeElement).select("svg").remove();

    // Remove existing hover tooltip
    d3.select(this.chartContainer.nativeElement).select(".bubble-hover-tooltip").remove();

    const { margin } = this.dimensions;

    // Measure container BEFORE creating SVG for reliable width
    const containerRect = this.chartContainer.nativeElement.getBoundingClientRect();
    const svgWidth = containerRect.width || this.dimensions.width || 800;
    const svgHeight = this.dimensions.height || this.defaultHeight;
    this.dimensions.width = svgWidth;
    this.dimensions.height = svgHeight;

    // Create SVG with explicit pixel dimensions
    this.svg = d3
      .select(this.chartContainer.nativeElement)
      .append("svg")
      .attr("width", svgWidth)
      .attr("height", svgHeight)
      .attr("viewBox", `0 0 ${svgWidth} ${svgHeight}`)
      .attr("preserveAspectRatio", "xMidYMid meet")
      .attr("role", "img")
      .attr(
        "aria-label",
        "Scatter plot showing institution discontinuation rates",
      );

    const chartWidth = svgWidth - margin.left - margin.right;
    const chartHeight = svgHeight - margin.top - margin.bottom;

    // Create main chart group
    this.chartGroup = this.svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    // Create scales with nice() for clean axis ticks
    const maxPatients = d3.max(this.institutions, (d) => d.totalPatients) || 5;
    const maxRate =
      d3.max(this.institutions, (d) => d.discontinuationRate) || 1;

    const xPadding = Math.max(10, maxPatients * 0.1);
    const yPadding = Math.max(2, maxRate * 0.1);

    this.xScale = d3
      .scaleLinear()
      .domain([0, maxPatients + xPadding])
      .nice()
      .range([0, chartWidth]);

    this.yScale = d3
      .scaleLinear()
      .domain([0, maxRate + yPadding])
      .nice()
      .range([chartHeight, 0]);

    // Add axes
    this.addAxes(chartWidth, chartHeight);

    // Add quadrant lines and labels
    this.addQuadrants(chartWidth, chartHeight);

    // Add lasso functionality
    this.setupLasso(chartWidth, chartHeight);

    // Create hover tooltip AFTER SVG so it renders on top
    this.hoverTooltip = d3.select(this.chartContainer.nativeElement)
      .append("div")
      .attr("class", "bubble-hover-tooltip")
      .style("opacity", 0)
      .style("pointer-events", "none");

    // Register scroll listener once to hide tooltip on any scroll
    if (!this.scrollHideHandler) {
      this.scrollHideHandler = () => {
        if (this.hoverTooltip) {
          this.hoverTooltip.style("opacity", 0);
        }
      };
      window.addEventListener('scroll', this.scrollHideHandler, { capture: true, passive: true });
    }

    // Add bubbles
    this.addBubbles();

    // Redraw the saved lasso path on the new SVG if selections exist
    if (this.lassoPoints.length > 0 && this.selectedInstitutions.length > 0) {
      const pathData = "M" + this.lassoPoints.map((p) => p.join(",")).join("L") + "Z";
      this.lassoPath.attr("d", pathData).style("display", null);
    }

    // Update HTML legend overflow state
    this.updateLegendOverflow();

    this.isLoading = false; // Set loading to false after rendering is complete
  }

  private addAxes(chartWidth: number, chartHeight: number): void {
    // Add gridlines
    // Vertical gridlines (for X-axis)
    const xGridlines = d3
      .axisBottom(this.xScale)
      .ticks(8)
      .tickSize(-chartHeight)
      .tickFormat(() => "");

    this.chartGroup
      .append("g")
      .attr("class", "x-gridlines")
      .attr("transform", `translate(0,${chartHeight})`)
      .call(xGridlines)
      .selectAll("line")
      .attr("stroke", "#e0e0e0")
      .attr("stroke-width", 1.5)
      .attr("stroke-dasharray", "10, 10");
    this.chartGroup
      .select(".x-gridlines")
      .selectAll(".domain")
      .style("display", "none");

    // Horizontal gridlines (for Y-axis)
    const yGridlines = d3
      .axisLeft(this.yScale)
      .ticks(8)
      .tickSize(-chartWidth)
      .tickFormat(() => "");

    this.chartGroup
      .append("g")
      .attr("class", "y-gridlines")
      .call(yGridlines)
      .selectAll("line")
      .attr("stroke", "#e0e0e0")
      .attr("stroke-width", 1.5)
      .attr("stroke-dasharray", "10, 10");
    this.chartGroup
      .select(".y-gridlines")
      .selectAll(".domain")
      .style("display", "none");

    // X-axis
    const xAxis = d3
      .axisBottom(this.xScale)
      .ticks(8)
      .tickFormat((d) => d.toString());

    this.chartGroup
      .append("g")
      .attr("class", "x-axis")
      .attr("transform", `translate(0,${chartHeight})`)
      .call(xAxis)
      .selectAll("text")
      .attr("fill", "#8A98AB");

    // Hide x-axis,line domain only
    this.chartGroup
      .select(".x-axis")
      .selectAll(".domain")
      .style("display", "none");
    this.chartGroup
      .select(".x-axis")
      .selectAll(".tick line")
      .style("display", "none");

    // X-axis label
    this.chartGroup
      .append("text")
      .attr("class", "axis-label")
      .attr("x", chartWidth / 2)
      .attr("y", chartHeight + 40)
      .attr("text-anchor", "middle")
      .attr("fill", "#101D42CC")
      .attr("font-size", 12)
      .attr("font-weight", "600")
      .attr("font-family", "Poppins")
      .text(this.props.xAxisLabel||"Patients");

    // Y-axis
    const yAxis = d3
      .axisLeft(this.yScale)
      .ticks(8)
      .tickFormat((d) => `${d}%`);

    this.chartGroup
      .append("g")
      .attr("class", "y-axis")
      .call(yAxis)
      .selectAll("text")
      .attr("fill", "#8A98AB");

    // Hide y-axis,line domain only
    this.chartGroup
      .select(".y-axis")
      .selectAll(".domain")
      .style("display", "none");
    this.chartGroup
      .select(".y-axis")
      .selectAll(".tick line")
      .style("display", "none");

    // Y-axis label
    this.chartGroup
      .append("text")
      .attr("class", "axis-label")
      .attr("transform", "rotate(-90)")
      .attr("x", -chartHeight / 2)
      .attr("y", -45)
      .attr("text-anchor", "middle")
      .attr("fill", "#101D42CC")
      .attr("font-size", 12)
      .attr("font-weight", "600")
      .attr("font-family", "Poppins")
      .text(( this.activeTab=='more' ? 'Discontinuation Rate' : 'Early Drop-off Rate'));
      // .text(this.props.yAxisLabel || "Discontinuation rate");
  }

  private addQuadrants(chartWidth: number, chartHeight: number): void {
    // Calculate dynamic quadrant lines (center of chart - 4 equal parts)
    const maxPatients = d3.max(this.institutions, (d) => d.totalPatients) || 5;
    const maxRate =
      d3.max(this.institutions, (d) => d.discontinuationRate) || 1;

    // Center lines divide chart into 4 equal quadrants
    const horizontalLine = maxRate / 2; // Configurable: middle of discontinuation rate
    const verticalLine = maxPatients / 2; // Configurable: middle of total patients

    // Quadrant background colors
    const quadrantColors = [
      { show: false, bgColor: "#FFF3E0", name: "Lower volume - Higher risk" }, // Top-left
      { show: true, bgColor: "#FFEBEE", name: "Higher volume - Higher risk" }, // Top-right
      { show: false, bgColor: "#E8F5E9", name: "Lower volume - Lower risk" }, // Bottom-left
      { show: false, bgColor: "#E8F5E9", name: "Higher volume - Lower risk" }, // Bottom-right
    ];

    // Add quadrant background rectangles
    const quadrants = [
      {
        show: quadrantColors[0].show,
        x: 0,
        y: 0,
        width: this.xScale(verticalLine),
        height: this.yScale(horizontalLine),
        bgColor: quadrantColors[0].bgColor,
      }, // Top-left
      {
        show: quadrantColors[1].show,
        x: this.xScale(verticalLine),
        y: 0,
        width: chartWidth - this.xScale(verticalLine),
        height: this.yScale(horizontalLine),
        bgColor: quadrantColors[1].bgColor,
      }, // Top-right
      {
        show: quadrantColors[2].show,
        x: 0,
        y: this.yScale(horizontalLine),
        width: this.xScale(verticalLine),
        height: chartHeight - this.yScale(horizontalLine),
        bgColor: quadrantColors[2].bgColor,
      }, // Bottom-left
      {
        show: quadrantColors[3].show,
        x: this.xScale(verticalLine),
        y: this.yScale(horizontalLine),
        width: chartWidth - this.xScale(verticalLine),
        height: chartHeight - this.yScale(horizontalLine),
        bgColor: quadrantColors[3].bgColor,
      }, // Bottom-right
    ];

    quadrants.forEach((quad) => {
      this.chartGroup
        .append("rect")
        .attr("class", "quadrant-bg")
        .attr("x", quad.x)
        .attr("y", quad.y)
        .attr("width", quad.width)
        .attr("height", quad.height)
        .attr("fill", quad.show ? quad.bgColor : "transparent")
        .attr("opacity", 0.4);
    });

    // Horizontal line
    this.chartGroup
      .append("line")
      .attr("class", "quadrant-line")
      .attr("x1", 0)
      .attr("y1", this.yScale(horizontalLine))
      .attr("x2", chartWidth)
      .attr("y2", this.yScale(horizontalLine))
      .attr("stroke", "#8A98AB")
      .attr("stroke-width", 1.5)
      .attr("stroke-dasharray", "10, 10");

    // Vertical line
    this.chartGroup
      .append("line")
      .attr("class", "quadrant-line")
      .attr("x1", this.xScale(verticalLine))
      .attr("y1", 0)
      .attr("x2", this.xScale(verticalLine))
      .attr("y2", chartHeight)
      .attr("stroke", "#8A98AB")
      .attr("stroke-width", 1.5);
    // .attr('stroke-dasharray', '4,4');

    // Quadrant labels with colored backgrounds - positioned in corners
    const labels = [
      {
        text: "Higher volume - Higher risk",
        x: chartWidth,
        y: 20,
        bgColor: "#F7D9D5",
        iconColor: "#D7402D",
        align: "end",
        iconAlign: "end",
      },
      {
        text: "Higher volume - Lower risk",
        x: chartWidth,
        y: chartHeight - 18,
        bgColor: "#D8F4E5",
        iconColor: "#3AC97C",
        align: "end",
        iconAlign: "end",
      },
      {
        text: "Lower volume - Higher risk",
        x: 2,
        y: 20,
        bgColor: "#FDEFD9",
        iconColor: "#F4B040",
        align: "start",
        iconAlign: "end",
      },
      {
        text: "Lower volume - Lower risk",
        x: 2,
        y: chartHeight - 18,
        bgColor: "#EFF4D8",
        iconColor: "#90B72D",
        align: "start",
        iconAlign: "end",
      },
    ];

    const ICON_SIZE = 14;
    const ICON_GAP = 2;
    const PADDING = 4;

    labels.forEach((label) => {
      const align = label.align ?? "start";
      const iconAlign = label.iconAlign ?? "end";

      // Measure text
      const tempText = this.chartGroup
        .append("text")
        .attr("class", "quadrant-label")
        .attr("x", label.x)
        .attr("y", label.y)
        .attr("font-size", 10)
        .attr("font-family", "Poppins")
        .attr("text-anchor", align)
        .text(label.text);

      const bbox = (tempText.node() as SVGTextElement).getBBox();
      tempText.remove();

      const totalWidth = bbox.width + ICON_SIZE + ICON_GAP + PADDING * 2;
      const height = bbox.height + PADDING * 2;

      const bgX = align === "end" ? label.x - totalWidth : label.x;

      const bgY = bbox.y - PADDING;

      // Background
      this.chartGroup
        .append("rect")
        .attr("class", "quadrant-label-bg")
        .attr("x", bgX)
        .attr("y", bgY)
        .attr("width", totalWidth)
        .attr("height", height)
        .attr("rx", 6)
        .attr("fill", label.bgColor)
        .attr("opacity", 0.95);

      // Icon
      const iconX =
        iconAlign === "start"
          ? bgX + PADDING
          : bgX + totalWidth - ICON_SIZE - PADDING;

      const iconY = bgY + (height - ICON_SIZE) / 2;

      const iconGroup = this.chartGroup
        .append("g")
        .attr("class", "quadrant-icon")
        .attr("transform", `translate(${iconX}, ${iconY})`);

      iconGroup
        .append("svg")
        .attr("width", ICON_SIZE)
        .attr("height", ICON_SIZE)
        .attr("viewBox", "0 0 12 12")
        .attr("fill", "none")
        .attr("xmlns", "http://www.w3.org/2000/svg")
        .html(`<path d="M6 8L6 6" stroke="${label.iconColor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.66205 8.78838C6.29578 11.1546 5.79289 11.2433 3.17157 8.622C0.550252 6.00068 0.63604 5.50068 3.17157 2.96515C5.70711 0.429613 6.11396 0.250679 8.82843 2.96515C11.5429 5.67961 11.4497 6.00068 8.66205 8.78838Z" stroke="${label.iconColor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 4C6.13807 4 6.25 3.88807 6.25 3.75C6.25 3.61193 6.13807 3.5 6 3.5C5.86193 3.5 5.75 3.61193 5.75 3.75C5.75 3.88807 5.86193 4 6 4Z" fill="${label.iconColor}" stroke="${label.iconColor}" stroke-linecap="round" stroke-linejoin="round"/>`);

      // Text
      const textX =
        align === "end"
          ? bgX + totalWidth - ICON_SIZE - ICON_GAP - PADDING
          : bgX + PADDING;

      this.chartGroup
        .append("text")
        .attr("class", "quadrant-label")
        .attr("x", textX)
        .attr("y", label.y)
        .attr("font-size", 10)
        .attr("font-family", "Poppins")
        .attr("fill", label.iconColor)
        .attr("text-anchor", align === "end" ? "end" : "start")
        .text(label.text);
    });
  }

  private setupLasso(chartWidth: number, chartHeight: number): void {
    // Create lasso group
    this.lassoArea = this.chartGroup.append("g").attr("class", "lasso-group");

    this.lassoPath = this.lassoArea
      .append("path")
      .attr("class", "lasso-path")
      .attr("stroke", "#2196F3")
      .attr("stroke-width", 2)
      .attr("stroke-dasharray", "5,5")
      .attr("fill", "rgba(33, 150, 243, 0.15)")
      .style("display", "none")
      .style("pointer-events", "none");

    // Setup d3 drag behavior for robust lasso handling
    let isDragging = false;
    let startX: number = 0;
    let startY: number = 0;
    let lassoPointsSnapshot: [number, number][] = [];

    const lasso = d3
      .drag<SVGRectElement, unknown>()
      .on(
        "start",
        (event: d3.D3DragEvent<SVGRectElement, unknown, unknown>) => {
          // Reset dragging state and prepare for potential drag
          isDragging = false;
          startX = event.x;
          startY = event.y;
        },
      )
      .on("drag", (event: d3.D3DragEvent<SVGRectElement, unknown, unknown>) => {
        // Check if we've moved far enough to be considered a "drag" (threshold: 5px)
        if (
          !isDragging &&
          (Math.abs(event.x - startX) > 5 || Math.abs(event.y - startY) > 5)
        ) {
          isDragging = true;

          // Hide tooltip while drawing new lasso
          this.showSelectionTooltip = false;

          // Reset lasso and selections unless shift key is pressed
          const isShiftPressed =
            event.sourceEvent && (event.sourceEvent as MouseEvent).shiftKey;
          if (!isShiftPressed) {
            this.institutions.forEach((inst) => (inst.selected = false));
            this.updateBubbleSelections();
            lassoPointsSnapshot = [];
            this.lassoPoints = [];
            this.lassoPath.attr("d", "").style("display", "none");
          }
        }

        // If not dragging, do nothing
        if (!isDragging) return;

        // Draw the lasso path as user drags
        const [x, y] = d3.pointer(
          event.sourceEvent as MouseEvent,
          this.chartGroup.node(),
        );
        this.lassoPoints.push([x, y]);

        // Update lasso visual in real-time
        const pathData =
          "M" + this.lassoPoints.map((p) => p.join(",")).join("L") + "Z";
        this.lassoPath.attr("d", pathData).style("display", null);
      })
      .on("end", (event: d3.D3DragEvent<SVGRectElement, unknown, unknown>) => {
        if (isDragging) {
          // ACTION WAS A DRAG: Complete the lasso selection
          if (this.lassoPoints.length > 2) {
            lassoPointsSnapshot = [...this.lassoPoints];

            // Check which points are inside the lasso
            // Skip dimmed (legend-filtered) bubbles
            this.institutions.forEach((inst) => {
              const x = this.xScale(inst.totalPatients);
              const y = this.yScale(inst.discontinuationRate);

              if (this.isPointInPolygon([x, y], lassoPointsSnapshot)) {
                if (this.selectedTerritories.size === 0 || this.selectedTerritories.has(inst.territory)) {
                  inst.selected = !inst.selected;
                }
              }
            });

            this.updateSelection();

            // If no bubbles were selected, clear the lasso
            if (this.selectedInstitutions.length === 0) {
              this.lassoPath.attr("d", "").style("display", "none");
              this.lassoPoints = [];
              lassoPointsSnapshot = [];
            } else {
              // Show tooltip at lasso centroid with a small delay for smooth rendering
              setTimeout(() => {
                this.showTooltipAtLasso(lassoPointsSnapshot);
              }, 100);
            }
          }

          // Keep lasso path visible until tooltip is closed
          // It will be hidden when closeSelectionTooltip() or resetSelection() is called
        } else {
          // ACTION WAS A CLICK: Toggle tooltip visibility
          // This allows users to click to show/hide the tooltip
          if (this.selectedInstitutions.length > 0) {
            this.showSelectionTooltip = !this.showSelectionTooltip;
          }
        }

        // Reset dragging flag for next action
        isDragging = false;
      });

    // Apply drag behavior to chart background
    this.chartGroup
      .append("rect")
      .attr("class", "lasso-background")
      .attr("width", chartWidth)
      .attr("height", chartHeight)
      .attr("fill", "transparent")
      .attr("pointer-events", "all")
      .call(lasso);
  }

  private showTooltipAtLasso(lassoPoints?: [number, number][]): void {
    // Calculate centroid of lasso points or use first selected institution
    let selectionCenterX = 0;
    let selectionCenterY = 0;

    if (lassoPoints && lassoPoints.length > 0) {
      // Use centroid of lasso points
      selectionCenterX =
        lassoPoints.reduce((sum, p) => sum + p[0], 0) / lassoPoints.length;
      selectionCenterY =
        lassoPoints.reduce((sum, p) => sum + p[1], 0) / lassoPoints.length;
    } else if (this.selectedInstitutions.length > 0) {
      // Use first selected institution's position
      const firstInst = this.selectedInstitutions[0];
      selectionCenterX = this.xScale(firstInst.totalPatients);
      selectionCenterY = this.yScale(firstInst.discontinuationRate);
    }

    const margin = this.dimensions.margin;
    const containerWidth = this.dimensions.width;
    const containerHeight = this.dimensions.height;

    // Responsive tooltip dimensions
    const tooltipWidth =
      containerWidth > 768 ? 420 : containerWidth > 600 ? 360 : 300;
    const tooltipHeight = 320;
    const padding = 10;
    const offset = 20; // Distance from selection boundary

    // Calculate lasso bounding box
    const lassoBox = this.calculateLassoBoundingBox(lassoPoints);
    const lassoBounds = {
      minX: lassoBox.minX + margin.left,
      maxX: lassoBox.maxX + margin.left,
      minY: lassoBox.minY + margin.top,
      maxY: lassoBox.maxY + margin.top,
    };

    const centerX = selectionCenterX + margin.left;
    const centerY = selectionCenterY + margin.top;

    // Position as top-left corner (no CSS transform centering)
    // Try right of lasso, then left, then below, then above
    let x: number;
    let y: number;
    let placed = false;

    // Right side
    const rightX = lassoBounds.maxX + offset;
    if (rightX + tooltipWidth <= containerWidth - padding) {
      x = rightX;
      y = Math.max(padding, Math.min(centerY - tooltipHeight / 2, containerHeight - tooltipHeight - padding));
      placed = true;
    }

    // Left side
    if (!placed) {
      const leftX = lassoBounds.minX - offset - tooltipWidth;
      if (leftX >= padding) {
        x = leftX;
        y = Math.max(padding, Math.min(centerY - tooltipHeight / 2, containerHeight - tooltipHeight - padding));
        placed = true;
      }
    }

    // Below
    if (!placed!) {
      const belowY = lassoBounds.maxY + offset;
      if (belowY + tooltipHeight <= containerHeight - padding) {
        x = Math.max(padding, Math.min(centerX - tooltipWidth / 2, containerWidth - tooltipWidth - padding));
        y = belowY;
        placed = true;
      }
    }

    // Above
    if (!placed) {
      const aboveY = lassoBounds.minY - offset - tooltipHeight;
      if (aboveY >= padding) {
        x = Math.max(padding, Math.min(centerX - tooltipWidth / 2, containerWidth - tooltipWidth - padding));
        y = aboveY;
        placed = true;
      }
    }

    // Fallback: clamp to container
    if (!placed) {
      x = Math.max(padding, Math.min(centerX - tooltipWidth / 2, containerWidth - tooltipWidth - padding));
      y = Math.max(padding, Math.min(centerY - tooltipHeight / 2, containerHeight - tooltipHeight - padding));
    }

    this.tooltipPosition = { x: x!, y: y! };
    this.showSelectionTooltip = true;
  }

  private calculateLassoBoundingBox(lassoPoints?: [number, number][]): {
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
  } {
    if (!lassoPoints || lassoPoints.length === 0) {
      return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
    }

    let minX = Infinity,
      maxX = -Infinity,
      minY = Infinity,
      maxY = -Infinity;

    lassoPoints.forEach((point) => {
      minX = Math.min(minX, point[0]);
      maxX = Math.max(maxX, point[0]);
      minY = Math.min(minY, point[1]);
      maxY = Math.max(maxY, point[1]);
    });

    return { minX, maxX, minY, maxY };
  }

  private isPointInPolygon(
    point: [number, number],
    polygon: [number, number][],
  ): boolean {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0],
        yi = polygon[i][1];
      const xj = polygon[j][0],
        yj = polygon[j][1];

      const intersect =
        yi > point[1] !== yj > point[1] &&
        point[0] < ((xj - xi) * (point[1] - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }

  private addBubbles(): void {
    // Chart bounds for clamping
    const { margin } = this.dimensions;
    const chartWidth = this.dimensions.width - margin.left - margin.right;
    const chartHeight = this.dimensions.height - margin.top - margin.bottom;

    // Pre-compute jitter offsets for overlapping bubbles
    const jitterMap = this.computeJitterOffsets();

    const bubbles = this.chartGroup
      .selectAll(".bubble")
      .data(this.institutions, (d: any) => d.id)
      .enter()
      .append("g")
      .attr("class", "bubble-group")
      .attr(
        "transform",
        (d: any) => {
          const jitter = jitterMap.get(d.id) || { dx: 0, dy: 0 };
          const r = this.getBubbleRadius(d);
          // Clamp position so bubble stays within chart axes
          const x = Math.max(r, Math.min(chartWidth - r, this.xScale(d.totalPatients) + jitter.dx));
          const y = Math.max(r, Math.min(chartHeight - r, this.yScale(d.discontinuationRate) + jitter.dy));
          return `translate(${x},${y})`;
        },
      );

    // Outer circle for selection
    bubbles
      .append("circle")
      .attr("class", "bubble-selection")
      .attr("r", (d: any) => this.getBubbleRadius(d) + 4)
      .attr("fill", "none")
      .attr("stroke", "#2196F3")
      .attr("stroke-width", 2)
      .attr("stroke-dasharray", "4,4")
      .style("opacity", 0);

    // Main bubble circle
    bubbles
      .append("circle")
      .attr("class", "bubble")
      .attr("r", 0)
      .attr("fill", (d: any) =>
        this.getColorForTerritory(d.territory),
      )
      .attr("opacity", 0)
      .attr("cursor", "default")
      .transition()
      .duration(1000)
      .delay((d: any, i: number) => i * 20)
      .ease(d3.easeCubicOut)
      .attr("opacity", 0.6)
      .attr("r", (d: any) => this.getBubbleRadius(d))
      .selection()
      .on("click", (event: MouseEvent, d: any) => {
        // event.stopPropagation();
        // this.toggleInstitution(d);
      })
      .on("mouseenter", (event: MouseEvent, d: any) => {
        if (this.isLoading) return;
        const circle = d3.select(event.target as SVGCircleElement);
        const parentGroup = d3.select((event.target as SVGCircleElement).parentNode as SVGGElement);

        // Raise the bubble group above others
        parentGroup.raise();

        circle
          .transition()
          .duration(200)
          .attr("opacity", 1)
          .attr("r", this.getBubbleRadius(d) * 1.1);

        // Show hover tooltip
        const color = this.getColorForTerritory(d.territory);
        // <span class="tooltip-territory" style="color: ${color}">${d.territory}</span>
        this.hoverTooltip
          .html(`
            <div class="tooltip-header" style="border-left: 4px solid ${color}">
              <span class="tooltip-name">${d.name}</span>
            </div>
            <div class="tooltip-body">
              <div class="tooltip-row">
                <span class="tooltip-label">Total Patients</span>
                <span class="tooltip-value">${this.numbedPipe(d.totalPatients)}</span>
              </div>
              <div class="tooltip-row">
                <span class="tooltip-label"> ${this.activeTab=='less'?'Early drop-off rate' :'Disc. Rate'}</span>
                <span class="tooltip-value tooltip-value--danger">${this.numbedPipe(d.discontinuationRate)}%</span>
              </div>
              <div class="tooltip-row">
                <span class="tooltip-label">Disc. Patients</span>
                <span class="tooltip-value">${this.numbedPipe(d.discontinuedFiles)}</span>
              </div>
            </div>
          `)
          .transition()
          .duration(100)
          .style("opacity", 1);

        // Position tooltip near the cursor
        const containerRect = this.chartContainer.nativeElement.getBoundingClientRect();
        const tooltipNode = this.hoverTooltip.node() as HTMLElement;
        const tooltipWidth = tooltipNode.offsetWidth || 200;
        const tooltipHeight = tooltipNode.offsetHeight || 100;
        let left = event.clientX - containerRect.left + 14;
        let top = event.clientY - containerRect.top - tooltipHeight - 10;

        // Keep tooltip within container bounds
        if (left + tooltipWidth > containerRect.width) {
          left = event.clientX - containerRect.left - tooltipWidth - 14;
        }
        if (top < 0) {
          top = event.clientY - containerRect.top + 14;
        }

        this.hoverTooltip
          .style("left", left + "px")
          .style("top", top + "px");
      })
      .on("mousemove", (event: MouseEvent, d: any) => {
        if (this.isLoading) return;
        // Update tooltip position as mouse moves
        const containerRect = this.chartContainer.nativeElement.getBoundingClientRect();
        const tooltipNode = this.hoverTooltip.node() as HTMLElement;
        const tooltipWidth = tooltipNode.offsetWidth || 200;
        const tooltipHeight = tooltipNode.offsetHeight || 100;
        let left = event.clientX - containerRect.left + 14;
        let top = event.clientY - containerRect.top - tooltipHeight - 10;

        if (left + tooltipWidth > containerRect.width) {
          left = event.clientX - containerRect.left - tooltipWidth - 14;
        }
        if (top < 0) {
          top = event.clientY - containerRect.top + 14;
        }

        this.hoverTooltip
          .style("left", left + "px")
          .style("top", top + "px");
      })
      .on("mouseleave", (event: MouseEvent, d: any) => {
        const circle = d3.select(event.target as SVGCircleElement);
        circle
          .transition()
          .duration(100)
          .attr("opacity", 0.6)
          .attr("r", this.getBubbleRadius(d));

        // Hide hover tooltip
        this.hoverTooltip
          .transition()
          .duration(100)
          .style("opacity", 0);
      });

    // Add count labels if enabled
    if (this.showBubbleCount) {
      bubbles
        .append("text")
        .attr("class", "bubble-count")
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "middle")
        .attr("font-size", (d: any) => {
          const radius = this.getBubbleRadius(d);
          return Math.max(9, Math.min(14, radius * 0.6));
        })
        .attr("font-family", "Poppins")
        .attr("font-weight", "600")
        .attr("fill", "#fff")
        .attr("opacity", 0)
        .attr("pointer-events", "none")
        .text((d: any) => d.totalPatients)
        .transition()
        .duration(1000)
        .delay((d: any, i: number) => i * 20)
        .attr("opacity", 1);
    }

    // Update selection visuals
    this.updateBubbleSelections();
  }

  private getBubbleRadius(institution: any): number {
    // Base size on discontinuedFiles (patient_count / bubbleSizeVar)
    const minRadius = 4;
    const maxRadius = 30;
    const maxBubbleValue =
      d3.max(this.institutions, (d) => d.discontinuedFiles) || 100;

    const scale = d3
      .scaleSqrt()
      .domain([0, maxBubbleValue])
      .range([minRadius, maxRadius]);

    return scale(institution.discontinuedFiles);
  }

  /**
   * Detect overlapping bubbles (same or very close x/y values)
   * and assign radial offsets so they don't stack on the exact same spot.
   */
  private computeJitterOffsets(): Map<string, { dx: number; dy: number }> {
    const result = new Map<string, { dx: number; dy: number }>();

    // Wider threshold to catch nearby (not just identical) positions
    const threshold = 15;

    // Group institutions by their rendered pixel position
    const posGroups: any[][] = [];
    this.institutions.forEach((inst: any) => {
      const px = Math.round(this.xScale(inst.totalPatients));
      const py = Math.round(this.yScale(inst.discontinuationRate));
      (inst as any)._px = px;
      (inst as any)._py = py;

      // Find an existing group within threshold
      let matched = false;
      for (const group of posGroups) {
        const anchor = group[0];
        if (Math.abs(px - anchor._px) <= threshold && Math.abs(py - anchor._py) <= threshold) {
          group.push(inst);
          matched = true;
          break;
        }
      }

      if (!matched) {
        posGroups.push([inst]);
      }
    });

    // Spread overlapping groups using multiple rings
    posGroups.forEach((group) => {
      if (group.length <= 1) {
        result.set(group[0].id, { dx: 0, dy: 0 });
        return;
      }

      // Calculate average radius for spacing
      const avgRadius = group.reduce((sum: number, inst: any) => sum + this.getBubbleRadius(inst), 0) / group.length;
      const spacing = Math.max(avgRadius * 1.1, 10);

      // Place first bubble at center
      result.set(group[0].id, { dx: 0, dy: 0 });

      // Fill rings outward: ring 1 = 6 items, ring 2 = 12, ring 3 = 18, etc.
      let placed = 1;
      let ring = 1;
      while (placed < group.length) {
        const ringCapacity = ring * 6;
        const ringRadius = spacing * ring;
        const itemsThisRing = Math.min(ringCapacity, group.length - placed);

        for (let i = 0; i < itemsThisRing; i++) {
          const angle = (2 * Math.PI * i) / itemsThisRing - Math.PI / 2;
          result.set(group[placed].id, {
            dx: Math.cos(angle) * ringRadius,
            dy: Math.sin(angle) * ringRadius,
          });
          placed++;
        }
        ring++;
      }
    });

    return result;
  }

  toggleInstitution(institution: any): void {
    institution.selected = !institution.selected;
    this.updateSelection();
  }

  private updateSelection(): void {
    this.selectedInstitutions = this.institutions.filter((i) => i.selected);
    this.updateBubbleSelections();

    if (this.selectedInstitutions.length > 0) {
      // Show tooltip when institutions are selected
      this.showTooltipAtLasso();
    } else {
      // Hide lasso and tooltip when selection is empty
      this.showSelectionTooltip = false;
      this.lassoPath.style("display", "none");
      this.lassoPoints = [];
    }
  }

  private updateBubbleSelections(): void {
    this.chartGroup
      .selectAll(".bubble-group")
      .each((d: any, i: number, nodes: any[]) => {
        const group = d3.select(nodes[i]);
        group.select(".bubble-selection").style("opacity", d.selected ? 1 : 0);
      });
  }

  resetSelection(): void {
    this.lassoPath.style("display", "none");
    this.lassoPoints = [];
    if (this.filterApplied) {
      this.filterService.intractiveClickTrigger.next({ institutions: [], rowFilterKey: this.props?.territoryKeyVar || '' });
      this.filterApplied = false;
    }
    this.institutions.forEach((inst) => (inst.selected = false));
    this.updateSelection();
  }

  removeInstitution(institution: any): void {
    institution.selected = false;
    this.updateSelection();
  }

  closeSelectionTooltip(): void {
    this.showSelectionTooltip = false;
    // Only hide lasso if no institutions are selected
    if (this.selectedInstitutions.length === 0) {
      this.lassoPath.style("display", "none");
      this.lassoPoints = [];
    }
  }

  seePrescribers(): void {
    console.log("See prescribers for:", this.selectedInstitutions);
    // Emit structured payload: institutions array + the raw API field name the grid should filter on
    this.filterApplied = true;
    this.filterService.intractiveClickTrigger.next({
      institutions: this.selectedInstitutions,
      rowFilterKey: this.props?.territoryKeyVar || 'territory_key'
    });

    // Scroll down to the grid after applying the filter
    setTimeout(() => {
      const gridEl = document.querySelector('app-hierarchical-grid-chart');
      if (gridEl) {
        gridEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
  }

  getColorForTerritory(territory: string): string {
    const territoryColor = this.territoryColors.find(
      (tc) => tc.territory === territory,
    );
    return territoryColor ? territoryColor.color : "#999999";
  }

  getColorByIndex(index: number): string {
    if (this.props?.colors && this.props.colors.length > 0) {
      return this.props.colors[index % this.props.colors.length];
    }
    return this.colorPalette[index % this.colorPalette.length];
  }

  private getKeyTerritories(institutions: any[]): any[] {
    const territoryMap = new Map<
      string,
      { totalPatients: number; discontinuedCount: number }
    >();

    institutions.forEach((inst) => {
      const key = inst.territory;
      if (!territoryMap.has(key)) {
        territoryMap.set(key, { totalPatients: 0, discontinuedCount: 0 });
      }
      const data = territoryMap.get(key)!;
      data.totalPatients += inst.totalPatients;
      data.discontinuedCount += inst.discontinuedFiles;
    });

    const keyTerritories: any[] = [];
    territoryMap.forEach((value, key) => {
      const rate =
        value.totalPatients > 0
          ? (value.discontinuedCount / value.totalPatients) * 100
          : 0;
      keyTerritories.push({
        name: key,
        totalPatients: value.totalPatients,
        earlyDropOffRate: (rate).toFixed(2),
        //Math.round(rate),
      });
    });

    return keyTerritories
      .sort((a, b) => b.earlyDropOffRate - a.earlyDropOffRate)
      .slice(0, 3);
  }

  getTerritoryEntries(): any[] {
    return this.territoryColors.map((tc, index) => ({ 
      key: tc.territory, 
      value: tc.territory 
    }));
  }

  toggleTerritoryFilter(territory: string): void {
    if (this.selectedInstitutions.length > 0) {
      this.snackBar.open('Please reset the lasso selection before filtering by legend.', 'OK', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
      return;
    }
    if (this.selectedTerritories.has(territory)) {
      this.selectedTerritories.delete(territory);
    } else {
      this.selectedTerritories.add(territory);
    }
    this.applyTerritoryOpacity();
  }

  private applyTerritoryOpacity(): void {
    const hasSelection = this.selectedTerritories.size > 0;

    // Toggle opacity on existing bubbles — no re-render, no scale change
    this.chartGroup
      .selectAll(".bubble-group")
      .transition()
      .duration(300)
      .style("opacity", (d: any) => {
        if (!hasSelection) return 1;
        return this.selectedTerritories.has(d.territory) ? 1 : 0.1;
      });
  }

  isTerritorySelected(territory: string): boolean {
    return this.selectedTerritories.has(territory);
  }

  private updateBubbleVisibility(): void {
    this.applyTerritoryOpacity();
  }

  legendOverflow = false;
  @ViewChild('legendTrack') legendTrack!: ElementRef;

  private updateLegendOverflow(): void {
    setTimeout(() => {
      if (this.legendTrack) {
        const el = this.legendTrack.nativeElement as HTMLElement;
        const lineHeight = 26; // matches legend-item line-height + gap
        const maxVisibleHeight = lineHeight * 2 + 4; // 2 rows + small buffer
        this.legendOverflow = el.scrollHeight > maxVisibleHeight;
      }
    }, 50);
  }

  private updateLegendStyles(): void {
    // Legend is now HTML-based — Angular class bindings handle active/dimmed styling
  }

}
